App.prototype.openPopup = function(url, target, width, height, left, top, location, status, scrollbars, resizable) {

    var left = left || 200,
        top = top || 50,
        location = location && 'yes' || 'no',
        status = status && 'yes' || 'no',
        scrollbars = scrollbars && 'yes' || 'no',
        resizable = scrollbars && 'yes' || 'no'

	window.open(url, target, 'width='+ width +', height='+ height +', left='+ left +', top='+ top +', location='+ location +', status='+ status +', scrollbars='+ scrollbars +', resizable='+ resizable)
}

App.addModule(function(app) {

    app.on('loaded', () => {

        $(document).on('click', '[data-toggle="popup"]', function(event) {
        	
        	if (BS.isScreenMdMin()) {
        		
        		event.preventDefault();
        		
        		var anchor = $(this);
        		
        		var target = anchor.data('target') || null,
        			width = anchor.data('width') || 450,
        			height = anchor.data('height') || 350;
        		
                app.openPopup(this.href, target, width, height)
        	}
        });
    })
})
